import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import { Button } from "../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Note, NOTE_TYPE } from "../../../../components/note/note";
import { FC, useState } from "react";
import { ACCESS_SCOPES } from "../../../../models/User";
import currentPortalStore from "../../../../stores/current-portal-store";
import './missing-scope-modal.scss';

const missingScopesErrorsMap: Record<ACCESS_SCOPES, string> = {
	[ACCESS_SCOPES.WRITE_DISCOUNTS]: "Due to recent Shopify updates, you need to approve new permissions in order to continue processing store credit refunds smoothly."
}

const MissingScopeModal: FC<{ missingScope: ACCESS_SCOPES }> = ({ missingScope }) => {

	const scopeApproveRedirectUrl = currentPortalStore.currentPortal.approveScopesRedirectUrl;

	const [open, setOpen] = useState(true);

	if (!open || !missingScopesErrorsMap?.[missingScope]) {
		return null;
	}

	return (
		<DefaultModalLayout onCloseClicked={() => setOpen(false)} isCloseDisabled={false}>
			<div className="missing-scope-modal">
				<Note
					type={NOTE_TYPE.WARNING}
					caption="Action Required: Approve Permissions"
					body={missingScopesErrorsMap[missingScope]}
				/>

				<FontBody1 color={FONT_COLOR.PRIMARY3}>Please update your permissions now to avoid any disruptions.</FontBody1>

				<div className="missing-scope-modal-buttons">
					<Button text="Cancel" onClick={() => setOpen(false)} variant={BUTTON_VARIANTS.Tertiary} />
					<Button
						text="Approve permissions"
						onClick={() => {
							console.log("Approve permissions", {scopeApproveRedirectUrl});
							if (scopeApproveRedirectUrl) {
								(window.top ?? window).location.href = scopeApproveRedirectUrl
							}
						}}
						variant={BUTTON_VARIANTS.Primary}
						hasLoader={false}
						isLoading={false}
					/>
				</div>
			</div>
		</DefaultModalLayout>
	);
}

export default MissingScopeModal;